import { render, staticRenderFns } from "./CircleObject.vue?vue&type=template&id=3d186dfc&scoped=true&"
import script from "./CircleObject.vue?vue&type=script&lang=ts&"
export * from "./CircleObject.vue?vue&type=script&lang=ts&"
import style0 from "./CircleObject.vue?vue&type=style&index=0&id=3d186dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d186dfc",
  null
  
)

export default component.exports